"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupCoachingEventAvailableTimeFormat = void 0;
exports.GroupCoachingEventAvailableTimeFormat = 'h:mma';
